<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtros
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Status</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="[
              { label: 'Todos', value: '' },
              { label: 'Ativo', value: 'active' },
              { label: 'Inativo', value: 'inactive' },
            ]"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('updateFilter', { status: val })"
          />
        </b-col>

        <b-col
          v-if="false"
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Categoria</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="categoryFilter"
            :options="categoriesOptions"
            label="nome"
            :reduce="val => val"
            @input="(val) => $emit('updateFilter', { id_categoria: val })"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    statusFilter: {
      type: [String, null],
      default: '',
    },
    categoryFilter: {
      type: [String, null],
      default: '',
    },
    categoriesOptions: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
